export function classNames(...arr) {
  return arr.filter(Boolean).join(" ");
}
